<template>
  <div id="album">
    <div class="message_bar" v-show="messageShow > 0">
      <div v-show="messageShow == 1">
        <p class="loading" style="padding-top:15px;">Loading</p>
        <img src="@/assets/img/loading_new.gif" alt="loading">
      </div>
      <p style="padding: 10px;" v-show="messageShow == 2">{{message}}</p>
    </div>
    <div class="album" ref="album" :style="{height: containerHeight}">
      <template v-for="m in imageList">
        <div class="photo_container" :style="m.style" @click="startGallery(m.index)">
          <img class="photo_thumb border" :src="m.link" alt="" ref="thumb">
        </div>
      </template>
    </div>
    <div class="loader_bar" v-show="isLoading">
      <p class="loading">Loading</p>
      <img src="@/assets/img/loading_new.gif" alt="loading">
    </div>
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy"
      infinite-scroll-distance="130" class="scroll_div"></div>

    <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true" ref="pswp">
        <div class="pswp__bg"></div>
        <div class="pswp__scroll-wrap">
            <div class="pswp__container">
                <div class="pswp__item"></div>
                <div class="pswp__item"></div>
                <div class="pswp__item"></div>
            </div>
            <div class="pswp__ui pswp__ui--hidden">
                <div class="pswp__top-bar">
                    <div class="pswp__counter"></div>
                    <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
                    <button class="pswp__button pswp__button--share" title="Share"></button>
                    <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
                    <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
                    <div class="pswp__preloader">
                        <div class="pswp__preloader__icn">
                          <div class="pswp__preloader__cut">
                            <div class="pswp__preloader__donut"></div>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                    <div class="pswp__share-tooltip"></div>
                </div>
                <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
                </button>
                <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
                </button>
                <div class="pswp__caption">
                    <div class="pswp__caption__center"></div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import '@/assets/photoswipe/photoswipe.css'
import '@/assets/photoswipe/default-skin/default-skin.css'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from '@/assets/js/photoswipe-ui-default'
import iLayout from 'justified-layout'

export default {
  name: 'album',
  data () {
    return {
      page: 1,
      busy: true,
      isLoading: false,
      messageShow: 1,
      message: '',
      containerHeight: '1920px',
      photoswipeItems:[],
      imageList: [],
      images: [],
    }
  },
  created: function () {
    this.$store.dispatch('changeIndex', {linkName: 'home'});
    this.$store.dispatch('isLogin')
      .then(() => {
        let getAlbum = this.$store.getters.getAlbum;
        if (getAlbum) {
          this.page = getAlbum.page;
          this.images = getAlbum.images;
          this.messageShow = 0;
          this.resizeWindowWidth();
          this.iniPhotoItem(getAlbum.images);
          if (getAlbum.isAll) {
            this.busy = true;
            this.isLoading = false;
          } else {
            this.busy = false;
            this.isLoading = true;
          }
        } else {
          this.getAlbum();
        }
      })
      .catch((err) => {
        this.messageShow = 2;
        this.message = `[Error] ${err.message}`
      })
  },
  mounted: function () {
    this.$nextTick(function() {
      window.addEventListener('resize', this.resizeWindowWidth);
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeWindowWidth);
  },
  methods: {
    getAlbum() {
      this.$store.dispatch('post', {
        address: '/api/getAlbum',
        postData: {
          page: this.page,
        },
      })
        .then((data) => {
          if (data.status === 'OK') {
            let updateAlbum = {
              isAll: false,
              page: this.page,
              imageList: data.imageList,
            }
            this.images = this.images.concat(data.imageList);
            this.resizeWindowWidth();
            this.iniPhotoItem(data.imageList);
            this.messageShow = 0;
            if (this.images.length >= data.total) {
              updateAlbum.isAll = true;
              this.isLoading = false;
            } else {
              this.busy = false;
              this.isLoading = true;
            }
            this.$store.dispatch('updateAlbum', updateAlbum);
          } else {
            this.messageShow = 2;
            this.message = `[Server Error] ${data.message}`
          }
        })
        .catch((err) => {
          this.messageShow = 2;
          this.message = `[Error] ${err.message}`
        })
    },
    loadMore() {
      this.busy = true;
      this.page++;
      this.getAlbum();
    },
    iniPhotoItem(images) {
      for (let i of images) {
        let one = {};
        one.w = i.width;
        one.h = i.height;
        one.src = i.full;
        one.msrc = i.thumb;
        this.photoswipeItems.push(one);
      }
    },
    resizeWindowWidth() {
      let screenType = (document.documentElement.clientWidth >= 768)? 1:0;
      let containerWidth = this.$refs.album.clientWidth;

      const option = {
        boxSpacing: 5,
        containerPadding: 5,
        showWidows: true,
        containerWidth: containerWidth,
        targetRowHeight: screenType? 300:130
      };
      let layout = iLayout(this.images, option);

      this.containerHeight = layout.containerHeight + 'px';

      let imageList = []
      for (let i in layout.boxes) {
        let link = this.images[i].thumb;
        let one = { link: link, style: {} };
        one.index = i;
        one.style.width = layout.boxes[i].width + 'px';
        one.style.height = layout.boxes[i].height + 'px';
        one.style.top = layout.boxes[i].top + 'px';
        one.style.left = layout.boxes[i].left + 'px';
        imageList.push(one);
      }
      this.imageList = imageList;
    },
    startGallery(index) {
      const pswpElement = this.$refs.pswp;
      const indexInt = parseInt(index);
      const items = this.photoswipeItems;
      const options = {
        history: false,
        index: indexInt,
        bgOpacity: 0.9,
        getThumbBoundsFn: (indexInt) => {
          // find thumbnail element
          const thumbnail = this.$refs.thumb[indexInt];
          // get window scroll Y
          const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          // get position of element relative to viewport
          const rect = thumbnail.getBoundingClientRect();
          return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
        }
      };

      const gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .message_bar {
    color: #5E5E5E;
    background-color: #F5F5F5;
    position: relative;
    margin: 0px 50px 30px 50px;
    text-align: center;
  }
  .photo_container {
    cursor: pointer;
    position: absolute;
    display: inline-block;
    overflow: hidden;
  }
  .photo_container:after {
    border: 1px solid rgba(0, 0, 0, 0.1);
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .photo_thumb {
    width: 100%;
    height: 100%;
  }
  .album {
    background-color: #F5F5F5;
    position: relative;
    margin: 0px 50px 0px 50px;
    min-height: 320px;
  }
  .loader_bar {
    color: #5E5E5E;
    background-color: #F5F5F5;
    position: relative;
    margin: 0 50px 20px 50px;
    height: auto;
    text-align: center;
  }
  .loading {
    margin: 0;
    padding-top: 10px;
    font-family: fashionFetish;
    font-weight: 600;
    color: #5E5E5E;
    text-align: center;
    text-transform: uppercase;
    font-size: 9px;
  }
  .scroll_div {
    height: 30px;
  }

  @media screen and (max-width: 767px) {
    .message_bar {
      margin: 0px 10px 30px 10px;
    }
    .album {
      margin: 10px 0 0 0;
    }
    .loader_bar {
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/album.vue